'use client';

/**
 * ScrollToContactButton Component
 * 
 * A client component button that smoothly scrolls to the contact section
 * on the homepage. Used within server components that need scroll functionality.
 */

import Button from '@/components/ui/Button';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

export default function ScrollToContactButton({size = 'md'}: {size?: 'sm' | 'md' | 'lg'}) {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Button onClick={scrollToContact} size={size} className="inline-flex items-center gap-2">
      <span>Get Started</span>
      <ArrowRightIcon className="w-4 h-4" />
    </Button>
  );
}

